module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('MainMenu', {
    class: {
      floating: this.$route.path == '/'
    },
    on: {
      "pullSheetClick": function($event) {
        _vm.showPullSheet = !_vm.showPullSheet, _vm.showAccount = false
      },
      "accountClick": function($event) {
        _vm.showAccount = !_vm.showAccount, _vm.showPullSheet = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content",
    on: {
      "click": function($event) {
        _vm.showAccount = false, _vm.showPullSheet = false
      }
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('PullSheet', {
    class: {
      floating: this.$route.path == '/'
    },
    attrs: {
      "showing": _vm.showPullSheet
    },
    on: {
      "itemAdded": _vm.pullSheetAdded
    }
  }), _vm._v(" "), _c('Account', {
    class: {
      floating: this.$route.path == '/'
    },
    attrs: {
      "showing": _vm.showAccount
    }
  }), _vm._v(" "), _c('MainFooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-330397a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Site.vue
// module id = 187
// module chunks = 1